import { RecipientDetailDto, RecipientEditDto } from './recipient';

export const mapRecipientDetailToEdit = (
  dto: RecipientDetailDto
): RecipientEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name
});
